const equal = require('fast-deep-equal/es6/react');

exports.findVariantByOptions = (variants, selectedOptions) =>
  variants?.find(v => equal(v.selectedOptions, selectedOptions));

exports.applyOptionOrdering = (options = [], ordering = []) => {
  const remainingOptions = [...options];
  const newOrder = [];

  ordering.forEach(optName => {
    const index = remainingOptions.findIndex(
      o => o.name.toLowerCase() === optName
    );

    // remove found options from remainingOptions copy so we can append remaining to matches
    if (index >= 0) {
      const temp = remainingOptions[index];
      remainingOptions[index] = remainingOptions[remainingOptions.length - 1];
      remainingOptions[remainingOptions.length - 1] = temp;
      const opt = remainingOptions.pop();
      if (opt) newOrder.push(opt);
    }
  });

  return newOrder.concat(remainingOptions);
};
